import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

export type AnswerType = 'audio' | 'image' | 'text';

@Entity('config')
export class Config {

    @PrimaryGeneratedColumn()
    public id: number;

    @Column()
    public key: string;

    @Column('text', {
        name: 'value'
    })
    private _value: string;

    public get value(): any {
        return JSON.parse(this._value);
    }

    public set value(value: any) {
        this._value = JSON.stringify(value);
    }

    public toJSON() {
        return {
            id: this.id,
            value: this.value,
        }
    }

    public static createFromObject(object: any) {
        let config: Config = new Config();
        config.key = object.key;
        config.value = object.value;
        return config;
    }
}


// WEBPACK FOOTER //
// ./src/entities/config.ts